import * as types from '../constants/ActionTypes';
import firebaseApp from '../firebase';
import api from '../../config/api.js';

const database = firebaseApp.database();
const ref = '/sessions';

export function listenToSession(sessionId, user) {
  return (dispatch) => {

    // listen for changes
    database.ref(`${ref}/${sessionId}/comments`)
      .orderByChild("ts")
      .on('child_removed', snapshot => {
        dispatch({
          type: types.REMOVE_SESSION_COMMENT,
          payload: {
            'key': snapshot.key,
            'sessionId': sessionId
          }
        })
      })

    //listen for additions
    return database.ref(`${ref}/${sessionId}/comments`)
      .orderByChild("ts")
      .on('child_added', snapshot => {
        addUserToSessionComments(sessionId, user);
        database.ref(`/users`)
          .child(snapshot.val().user)
          .once('value')
          .then(userSnap => {
            // insert session
            let comment = snapshot.val();
            comment.user = userSnap.val();
            comment.id = snapshot.key
            dispatch({
              type: types.INSERT_SESSION_COMMENT,
              payload: {
                'data': comment,
                'key': snapshot.key,
                'sessionId': sessionId
              }
            })
            // add user id
            dispatch({
              type: types.INSERT_SESSION_USER,
              payload: {
                'user': snapshot.val().user,
                'sessionId': sessionId
              }
            })
          })
      })
  }
}



export function setSessionNotification(sessionId, users, comment, count) {

  return dispatch => {
    users.forEach(userId => {
      if (!count && count !== 0) {
        // send push notification
        api.post('/api/notification/new_comment', {
            userId: userId,
            comment: comment
          })
          .then(r => {})
          .catch(e => {
            console.log(e);
          })
      }

      database.ref(`/notifications/${userId}/sessions/${sessionId}`)
        .transaction(notification => {

          notification = notification || 0;
          if (!count && count !== 0) {
            let v = notification + 1;
            return v;
          } else {
            return count
          }
        }, function (error, committed, notification) {
          if (error) {} else if (!committed) {}
        });
    })

  }
}



export function listenToUserSessionNotifications(userId) {
  return (dispatch) => {
    database.ref(`/notifications/${userId}/sessions/`)

      .on('child_added', snapshot => {
        dispatch({
          type: types.UPDATE_SESSION_NOTIFICATION,
          payload: {
            'data': snapshot.val(),
            'sessionId': snapshot.getKey()
          }
        })
      })

    database.ref(`/notifications/${userId}/sessions/`)
      .on('child_changed', snapshot => {
        dispatch({
          type: types.UPDATE_SESSION_NOTIFICATION,
          payload: {
            'data': snapshot.val(),
            'sessionId': snapshot.getKey()
          }
        })
      })
  }
}

export function unListenToUserSessionNotifications(userId) {
  database.ref(`/notifications/${userId}/sessions`).off()
}

export function addUserToSessionComments(sessionId, user) {
  // add this user to the session and users
  database.ref(`${ref}/${sessionId}/users/${user.uid}`).set(true);
  database.ref(`/users/${user.uid}`).set(user);
}

export function unListenSession(sessionId) {
  return database.ref(ref).child(sessionId).child('comments').off()
}

export function addSession(sessionId, therapistUid = null, parentUid = null, ownerUid = null) {
  return (dispatch) => {
    let session = {
      comments: [],
      users: [{
        'name': 'joe'
      }]
    }
    database.ref(`${ref}/${sessionId}`)
      .set(session)
      .then((a) => {
        console.log('comment:', sessionId);
      })
  }
}


export function addCommentToSession(sessionId, comment) {
  return (dispatch) => {
    return database.ref(`${ref}/${sessionId}/comments`)
      .push(comment)
  }
}

export function deleteCommentFromSession(key, sessionId) {
  console.log('deleting... ', `${ref}/${sessionId}/comments/${key}`);
  return (dispatch) => {
    database.ref(`${ref}/${sessionId}/comments/${key}`).remove().then((a) => {
      console.log('deleted item', a);
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/comments.js